import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, filter, map, switchMap, take, tap } from 'rxjs/operators';
import { MessageService } from '../services/message.service';

@Injectable()
export class MessageInterceptor implements HttpInterceptor {

    constructor(
        private messageService: MessageService
    ) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    if (event?.body?.message?.length > 0) {
                        this.messageService.success(event?.body?.message);
                    }
                    return event;
                }
            })
        );
    }

}
